import app from 'app';
import mxPopover from 'components/tooltips/mxPopover/mxPopover';

import { logEvent, eventCategories } from 'helpers/analytics';

function ClaimValWithRemark() {
  const ClaimValWithRemark = this;

  function getRemarkCodeLines() {
    return ClaimValWithRemark.line.remarkCodes
      .map(remark => `<p>${remark.description}</p>`)
      .join('');
  }

  ClaimValWithRemark.$onInit = () => {
    ClaimValWithRemark.popover = {
      mouseleave() {
        logEvent('lineItemExpand', {
          category: eventCategories.ACTIVITY,
          planType: ClaimValWithRemark.planType
        });
      },
      component: mxPopover,
      locals: {
        content: `
          <p>${ClaimValWithRemark.buildCostExplanation()}</p>
          ${getRemarkCodeLines()}
        `
      },
      constraints: [
        {
          to: 'scrollParent',
          attachment: 'both'
        }
      ],
      attachment: 'bottom right',
      targetAttachment: 'top right',
      offset: '4px 0'
    };
  };
}

app.component('claimValWithRemark', {
  bindings: {
    buildCostExplanation: '&',
    line: '<',
    planType: '<'
  },
  controller: ClaimValWithRemark,
  controllerAs: 'ClaimValWithRemark',
  template: `
    <mx-tooltip class="ClaimLines--hasRemarkCodes" popover="ClaimValWithRemark.popover"
      mouseleave="ClaimValWithRemark.popover.mouseleave">
      {{::ClaimValWithRemark.line.patientResponsibility|currency:'$':2}}
    </mx-tooltip>
    <span class="ClaimLines--hiddenOnDesktop">
      {{::ClaimValWithRemark.line.patientResponsibility|currency:'$':2}}
    </span>
  `
});

export default 'claimValWithRemark';
